import type { WorkflowInputField } from '../../lib/workflow/workflowInputFields'
import { ChromeTextInput } from '../ChromeActions'
import { ChromeComposerTextarea } from '../ChromeComposerTextarea'
import { SelectMenu } from '../SelectMenu'

type Props = {
  angular: boolean
  fields: WorkflowInputField[]
  values: Record<string, string>
  disabled?: boolean
  onChange: (key: string, value: string) => void
}

export function WorkflowRunInputFields({ angular, fields, values, disabled, onChange }: Props) {
  if (fields.length === 0) {
    return <p className="text-sm text-ink-soft">当前工作流未声明运行输入字段。</p>
  }
  return (
    <div className="space-y-3">
      {fields.map((field) => (
        <label key={field.key} className="block text-sm font-semibold text-ink">
          {field.label}
          {field.required ? <span className="ml-1 text-accent">*</span> : null}
          {field.type === 'textarea' ? (
            <ChromeComposerTextarea
              angular={angular}
              className="mt-1.5"
              textareaClassName="min-h-24"
              value={values[field.key] ?? ''}
              disabled={disabled}
              placeholder={field.placeholder}
              onChange={(e) => onChange(field.key, e.target.value)}
            />
          ) : field.type === 'select' ? (
            <div className="mt-1.5">
              <SelectMenu
                ariaLabel={field.label}
                value={values[field.key] ?? ''}
                disabled={disabled}
                angular={angular}
                options={field.options ?? []}
                onChange={(value) => onChange(field.key, value)}
              />
            </div>
          ) : (
            <ChromeTextInput
              type={field.type === 'number' ? 'number' : 'text'}
              value={values[field.key] ?? ''}
              disabled={disabled}
              placeholder={field.placeholder}
              onChange={(e) => onChange(field.key, e.target.value)}
            />
          )}
        </label>
      ))}
    </div>
  )
}
